module.exports = __webpack_public_path__ + "static/media/2024-Retire-Ready-Box-Logged-Out.c3e23509.jpg";